/**
 * Enum para os perfis de usuário
 * São 4 níveis de acesso:
 * - ADMIN_CLIENTE: Administrador de empresa cliente
 * - VISUALIZADOR_CLIENTE: Visualizador de empresa cliente (somente leitura)
 * - ADMIN_GEOAMBIENTE: Administrador da Geoambiente (acesso completo)
 * - OPERADOR_GEOAMBIENTE: Operador da Geoambiente (acesso operacional)
 */
export enum UserRole {
  ADMIN_CLIENTE = 'Administrador',
  VISUALIZADOR_CLIENTE = 'Visualizador',
  ADMIN_GEOAMBIENTE = 'Administrador Geoambiente',
  OPERADOR_GEOAMBIENTE = 'Operador Geoambiente',
}

/**
 * Enum para status do usuário
 */
export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

/**
 * Interface para usuário (sem decorators TypeORM)
 */
export interface IUser {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  status: UserStatus;
  organizationId: number | null;
  lastAccess: Date | null;
  createdDate?: Date;
  lastModifiedDate?: Date;
  createdBy: string;
  lastModifiedBy: string | null;
}
